import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import InfoIcon from '@material-ui/icons/Info';
import { Box, Checkbox, FormControlLabel, Grid, TextField, Tooltip, Typography } from "@material-ui/core";
import { esFechaValida } from '../../../utils/FormatFecha';
import PickerMod from '../../../global/PickersMod';

const SeccionDestacarPaquete = ({ 
  tieneEstrella, 
  sobreDescuento,
  fechaLimiteDescuento,
  onToggleEstrella, 
  onSobreDescuentoChange,
  onFechaDescuentoChange
}) => {
  const handleFechaChange = (date) => {
    if (!esFechaValida({ date })) return;
    // Convertir la fecha a formato ISO string (como lo haría el input type="date")
    const fechaISO = date.toISOString().split('T')[0];
    onFechaDescuentoChange({ target: { value: fechaISO } });
  };

  return (
    <Grid container spacing={2} style={{ marginBottom: '20px', padding: '16px', border: '1px solid #eee', borderRadius: '8px' }}>
      <Grid item xs={12}>
        <Typography variant="h6" style={{ marginBottom: '16px' }}>Destacar Paquete</Typography>
      </Grid>
      
      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Checkbox
              icon={<StarBorderIcon />}
              checkedIcon={<StarIcon style={{ color: '#FFD700' }} />}
              checked={tieneEstrella}
              onChange={onToggleEstrella}
              name="tieneEstrella"
            />
          }
          label={
            <Box display="flex" alignItems="center">
              <Typography>Destacar este paquete</Typography>
              <Tooltip title="Aplicará un descuento adicional ficticio">
                <InfoIcon color="action" style={{ marginLeft: '8px' }} />
              </Tooltip>
            </Box>
          }
        />
      </Grid>

      {tieneEstrella && (
        <>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Porcentaje de descuento"
              value={sobreDescuento}
              onChange={onSobreDescuentoChange}
              InputProps={{
                endAdornment: '%',
                inputProps: { min: 1, max: 50 }
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <PickerMod
              id="fecha-limite-descuento-destacado"
              label="Fecha límite de descuento"
              selectedDate={fechaLimiteDescuento ? new Date(fechaLimiteDescuento) : null}
              setSelectedDate={handleFechaChange}
              inputVariant="standard"
              disablePast
              disableFuture={false}
            />
          </Grid>
          
          <Grid item xs={12}>
            <Typography variant="caption" color="textSecondary">
              El descuento ficticio estará activo hasta la fecha seleccionada
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default SeccionDestacarPaquete;